export default __webpack_public_path__ + "static/media/Group-face2.ca0bfb3f.png";